import { render, staticRenderFns } from "./ProfilesAllowed.vue?vue&type=template&id=1eb254e2&scoped=true&"
import script from "./ProfilesAllowed.vue?vue&type=script&lang=js&"
export * from "./ProfilesAllowed.vue?vue&type=script&lang=js&"
import style0 from "./ProfilesAllowed.vue?vue&type=style&index=0&id=1eb254e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb254e2",
  null
  
)

export default component.exports